import { render, staticRenderFns } from "./ImmediatePromotion.vue?vue&type=template&id=015c42e9&scoped=true"
import script from "./ImmediatePromotion.vue?vue&type=script&lang=js"
export * from "./ImmediatePromotion.vue?vue&type=script&lang=js"
import style0 from "./ImmediatePromotion.vue?vue&type=style&index=0&id=015c42e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015c42e9",
  null
  
)

export default component.exports